import { useCallback, useContext } from 'react';
import { useToast } from '@chakra-ui/react';
import { HttpContext } from '../context/HttpContext';
import CustomToast from '../common/CustomToast';

const useCancelBatch = () => {
  const { authAxios } = useContext(HttpContext);
  const toast = useToast();

  const cancelBatch = useCallback(
    async (batchId, options = {}) => {
      const { reload = true } = options;
      try {
        await authAxios.patch(`/api/v1/batches/${batchId}/cancel`);
        toast({
          render: (props) => (
            <CustomToast
              status="success"
              title="Batch cancelled"
              description="The batch has been cancelled."
              onClose={props.onClose}
              id={props.id}
            />
          ),
        });
        if (reload) {
          setTimeout(() => {
            window.location.reload(true);
          }, 800);
        }
      } catch (error) {
        toast({
          render: (props) => (
            <CustomToast
              status="error"
              title="Something went wrong"
              description={
                error?.response?.data?.message || 'Please try again later.'
              }
              onClose={props.onClose}
              id={props.id}
            />
          ),
        });
        throw error;
      }
    },
    [authAxios, toast]
  );

  return { cancelBatch };
};

export default useCancelBatch;
